import { PositionRow } from "@/components/PositionRow";
import { NewPositionRow } from "@/components/NewPositionRow";

const HEAD = [
  ["Typ", ""], ["Beschreibung", ""], ["Material", ""], ["Farbe", ""],
  ["Menge", "text-right"], ["Einzelpreis netto", "text-right"], ["Rabatt %", "text-right"], ["MwSt", "text-right"], ["Gesamt netto", "text-right"], ["Status", ""], ["", ""],
];

export function PositionsTable({ positionen, zeilen, locked, onUpdate, onDelete, onAdd }) {
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm" data-testid="auftrag-positions-table">
        <thead>
          <tr className="text-left text-xs uppercase tracking-wider text-slate-500 border-b border-slate-200">
            {HEAD.map(([label, cls], i) => <th key={i} className={`px-3 py-2 font-medium whitespace-nowrap ${cls}`}>{label}</th>)}
          </tr>
        </thead>
        <tbody data-testid="auftrag-positions-body">
          {positionen.map((p, idx) => <PositionRow key={p.id} p={p} idx={idx} z={zeilen?.[idx]} locked={locked} onUpdate={onUpdate} onDelete={onDelete} />)}
          {!locked && <NewPositionRow onAdd={onAdd} />}
        </tbody>
      </table>
    </div>
  );
}
